// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"6745":"7062c520a3d61afb","9880":"daa84b8d2f0d9454"}[chunkId] + ".js";
};